import { call, put, takeEvery } from "redux-saga/effects";
import axios from "axios";
import getEnvVars from "../environment";
const env = getEnvVars();

function* watcherSaga() {
  yield takeEvery("API_CALL_PROFILE_REQUEST", workerSaga);
}

function fetch() {
  const url = `${process.env.REACT_APP_LOCAL_API_URL}profile/`;

  return axios({
    method: "GET",
    ...env.axiosConfig,
    url: url,
  });
}

function* workerSaga(request) {
  try {
    const response = yield call(fetch, request.kind);
    const result = response.data;
    yield put({ type: "API_CALL_PROFILE_SUCCESS", result, kind: request.kind });
  } catch (error) {
    yield put({ type: "API_CALL_PROFILE_FAILURE", error });
  }
}

export default watcherSaga;
